module.exports = __webpack_public_path__ + "img/jira.5b854694.svg";